module.exports = __webpack_public_path__ + "static/media/Cardholder.3db10c72.svg";